import Vue from 'vue'
import VueI18n from 'vue-i18n'
import locale from 'element-ui/lib/locale'
import elementEN from 'element-ui/lib/locale/lang/en' // element-ui 英文包
import elementZH from 'element-ui/lib/locale/lang/zh-CN' // element-ui 中文包

// 引入自定义的语言包
import myZH from './zh'
import myEN from './en'

Vue.use(VueI18n)

const i18n = new VueI18n({
  // 指定默认语言包
  locale: 'en',
  messages: {
    en: {
      ...elementEN,
      ...myEN
    },
    zh: {
      ...elementZH,
      ...myZH
    }
  }
})

// 配置elementUI 语言转换关系
locale.i18n((key, value) => i18n.t(key, value))

export default i18n
